<template>
  <mdb-container>
    <section class="text-center my-5">
      <h2 class="h1-responsive font-weight-bold my-5">Pourquoi faire appel à nous?</h2>
      <p class="lead grey-text w-responsive mx-auto mb-5">Parce que nous sommes qualifiés, dynamiques et agiles et nous répondrons entièrement à vos attentes.</p>
      <mdb-row>
        <mdb-col md="4">
          <mdb-icon icon="chart-area" size="3x" class="red-text"/>
          <h5 class="font-weight-bold my-4">Qualifiés</h5>
          <p class="grey-text mb-md-0 mb-5">Nous mixons parfaitement nos compétences informatique et médicales afin de vous offrir un service complet.</p>
        </mdb-col>
        <mdb-col md="4">
          <mdb-icon icon="smile-beam" size="3x" class="cyan-text"/>
          <h5 class="font-weight-bold my-4">Dynamiques</h5>
          <p class="grey-text mb-md-0 mb-5">Les relations humaines sont le centre de notre vie. Il est important pour nous de transmettre de la bonne énergie partout où nous travaillons.</p>
        </mdb-col>
        <mdb-col md="4">
          <mdb-icon far icon="comments" size="3x" class="orange-text"/>
          <h5 class="font-weight-bold my-4">Agiles</h5>
          <p class="grey-text mb-md-0 mb-5">Nous fonctionnons en sprints, et c'est avec vous que nous validons/redirigeons le projet en fonction de vos attentes.</p>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  import { mdbContainer, mdbRow, mdbCol, mdbIcon, mdbBtn } from 'mdbvue';
  export default {
    name: 'FeaturesPage',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbIcon,
      mdbBtn
    }
  }
</script>